import _defineProperty from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useRef, useState, forwardRef } from 'react';
import useStyles from './styles';
import { useTheme } from 'react-jss';
import { Option } from '../Option';
import { Icon } from '../Icon';
import { Typography } from '../Typography';
import { ClickAwayListener } from '../ClickAwayListener';
import clsx from 'clsx';
import { Icons } from '../../types/icons';
var inputHeight = 48;
var Select = forwardRef(function (_ref, ref) {
  var _clsx, _clsx2, _clsx3, _clsx4;

  var options = _ref.options,
      onSelect = _ref.onSelect,
      label = _ref.label,
      selected = _ref.selected,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Selecione' : _ref$placeholder,
      _ref$customClassName = _ref.customClassName,
      customClassName = _ref$customClassName === void 0 ? '' : _ref$customClassName,
      _ref$inlineStyles = _ref.inlineStyles,
      inlineStyles = _ref$inlineStyles === void 0 ? {} : _ref$inlineStyles,
      dataCy = _ref.dataCy,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'absolute' : _ref$position,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError,
      _ref$messageError = _ref.messageError,
      messageError = _ref$messageError === void 0 ? '' : _ref$messageError;

  var _a;

  var theme = useTheme();
  var classes = useStyles({
    theme: theme
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var refIsNotFunction = ref && typeof ref !== 'function';
  var self = useRef(refIsNotFunction ? ref.current : null);
  var selfRect = (_a = self.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
  var optionFixedPosition = {
    width: selfRect === null || selfRect === void 0 ? void 0 : selfRect.width,
    top: (selfRect === null || selfRect === void 0 ? void 0 : selfRect.top) + inputHeight
  };

  var toggle = function toggle() {
    return setOpen(function (b) {
      return !b;
    });
  };

  var isSelected = Boolean(selected);
  var isFixed = position === 'fixed';
  var isAbsolute = position === 'absolute';
  var containerStyles = clsx((_clsx = {}, _defineProperty(_clsx, classes.container, true), _defineProperty(_clsx, customClassName, Boolean(customClassName)), _clsx));
  var labelStyle = clsx((_clsx2 = {}, _defineProperty(_clsx2, classes.label, true), _defineProperty(_clsx2, classes.placeholder, !isSelected), _defineProperty(_clsx2, classes.disabled, disabled), _clsx2));
  var optionStyle = clsx((_clsx3 = {}, _defineProperty(_clsx3, classes.option, true), _defineProperty(_clsx3, classes.optionAbsolute, isAbsolute), _defineProperty(_clsx3, classes.optionFixed, isFixed), _clsx3));
  var inputStyle = clsx((_clsx4 = {}, _defineProperty(_clsx4, classes.input, true), _defineProperty(_clsx4, classes.inputError, hasError), _defineProperty(_clsx4, classes.disabled, disabled), _clsx4));
  return React.createElement("div", {
    className: containerStyles,
    style: inlineStyles
  }, React.createElement("span", {
    className: classes.label,
    onClick: disabled ? null : toggle
  }, React.createElement(Typography, {
    variant: 'content2',
    center: true
  }, label)), React.createElement("div", {
    tabIndex: 0,
    className: inputStyle,
    ref: self,
    onClick: disabled ? null : toggle,
    "data-cy": dataCy
  }, React.createElement(Typography, {
    variant: 'content2',
    customClassName: labelStyle
  }, isSelected ? selected.label : placeholder), React.createElement(Icon, {
    name: !open ? Icons.CaretDown : Icons.CaretUp,
    fill: isSelected ? '#4b4b4b' : '#acacac',
    customClassName: classes.icon
  }), open && React.createElement(ClickAwayListener, {
    onClickAway: function onClickAway() {
      return setOpen(false);
    }
  }, React.createElement("div", {
    className: optionStyle,
    style: isFixed ? optionFixedPosition : {}
  }, options.map(function (option) {
    return React.createElement(Option, {
      key: option.id,
      option: option,
      onSelectOption: onSelect,
      active: false
    });
  })))), hasError && React.createElement(Typography, {
    variant: 'content3',
    color: 'danger',
    customClassName: classes.bottomError
  }, messageError));
});
export { Select };